import React from 'react'

import Icon from '@/icons'
import Container from '@/container'

import './styles.css'

const MainSectionLayout = ({ title, about, children, noLogo, className }) => (
  <section className={`pb5 pb6-m pt7 ${className || ''}`}>
    <Container>
      <div className="tc">
        {!noLogo && <Icon icon="nmLogo" className="mb4 size90" />}
        <h1 className="mt0 mb3 f6 f5-m f4-l fw5">{title}</h1>
        <p className="mt0 mb6 f8 f7-m f6-l fw3 mw800 center">{about}</p>
      </div>

      {children}
    </Container>
  </section>
)

export default MainSectionLayout



// WEBPACK FOOTER //
// ./src/components/main-section-layout/main-section-layout.js